import { UAPI_URL_ONVIF } from "../config";
import { getRequestHandler, postRequestHandler } from "../utils/utils";

//#region Api Calling for Getting the Devices Discover
export const getDiscoverDeviceList= async (obj) => {
  const { DeviceType } = obj;
  let url = UAPI_URL_ONVIF + "discover/discoverDevices";
  if (DeviceType) {
    url += `?DeviceType=${DeviceType}`;
  }
  return getRequestHandler(url);
};

//#region Api Calling for Getting the Device Additional Information
export const getDeviceInformation = async (ip, username, password) => {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      authcode: localStorage.getItem("authCode"),
      Authorization: "Bearer " + localStorage.getItem("authToken"),
    },
    body: JSON.stringify({
      ip: ip,
      username: username,
      password: password
    }),
  };
  //let url = UAPI_URL_ONVIF + "discover/getDeviceInformation?ip=" + ip + "&username=" + username + "&password=" + password;
  let url = UAPI_URL_ONVIF + "discover/getDeviceInformation";
  return await fetch(url, requestOptions)
    .then((resp) => resp.json())
    .then(function (data) {
      return data;
    })
    .catch(function (error) {
      console.error("getDeviceInformation () Exception: ", error);
    });
};

export const getRecordingConfigurationDetails = async (ip, username, password) => {
  
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      authcode: localStorage.getItem("authCode"),
      Authorization: "Bearer " + localStorage.getItem("authToken"),
    },
    body: JSON.stringify({
      ip: ip,
      username: username,
      password: password
    }),
  };
  let url = UAPI_URL_ONVIF + "recording/getRecordingDetails";
  return await fetch(url, requestOptions)

    .then((resp) => resp.json())
    .then(function (data) {
      return data;
    })
    .catch(function (error) {
      console.error("getRecordingConfigurationDetails () Exception: ", error);
    });
};

export const getPTZPresets = async (ip, username, password) => {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      authcode: localStorage.getItem("authCode"),
      Authorization: "Bearer " + localStorage.getItem("authToken"),
    },
    body: JSON.stringify({
      ip: ip,
      username: username,
      password: password
    }),
  };
  let url = UAPI_URL_ONVIF + "ptz/fetchDevicePreset";
  return await fetch(url, requestOptions)
    .then((resp) => resp.json())
    .then(function (data) {
      return data;
    })
    .catch(function (error) {
      console.error("fetchDevicePreset () Exception: ", error);
    });
};

export const callingHomePosition = async (ip, username, password) => {
  
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      authcode: localStorage.getItem("authCode"),
      Authorization: "Bearer " + localStorage.getItem("authToken"),
    },
    body: JSON.stringify({
      ip: ip,
      username: username,
      password: password
    }),
  };
  let url = UAPI_URL_ONVIF + "ptz/callHomePosition";
  return await fetch(url, requestOptions)

    .then((resp) => resp.json())
    .then(function (data) {
      return data;
    })
    .catch(function (error) {
      console.error("callingHomePosition () Exception: ", error);
    });
};

export const callPTZPreset = async (obj) => {
  const requestOptions = {
    headers: {
      "Content-Type": "application/json"
  },
  body: JSON.stringify(obj)
  };
  let url = UAPI_URL_ONVIF + "ptz/callPreset";

  return await fetch(url, { ...requestOptions, method: "POST" })
    .then((resp) => resp.json())
    .then(function (data) {
      return data;
    })
    .catch(function (error) {
      console.error("callPTZPreset () Exception: ", error); 
    })

};

export const ptzControl = async (obj) => {
  const requestOptions = {
    headers: {
      "Content-Type": "application/json"
  },
  body: JSON.stringify(obj)
  };
  let url = UAPI_URL_ONVIF + "ptz/ptzControl";

  return await fetch(url, { ...requestOptions, method: "POST" })
    .then((resp) => resp.json())
    .then(function (data) {
      return data;
    })
    .catch(function (error) {
      console.error("ptzControl () Exception: ", error); 
    })

};

//#endregion